import useFetchService from '@/composables/useFetchService';

export default function useInquireService() {
  /********************
   * COMPOSITIONS      *
   ********************/
  const runtimeConfig = useRuntimeConfig();
  const fetchService = useFetchService({ base: runtimeConfig.public.apiUrl });

  /********************
   * FUNCTIONS         *
   ********************/
  function confirm(lang: string, data: any) {
    return fetchService.post('/inquiries/confirm/', lang, data);
  }

  function create(lang: string, data: any) {
    return fetchService.post('/inquiries/', lang, data);
  }

  return {
    confirm,
    create,
  };
}
